// extracted by mini-css-extract-plugin
export var audioPlayer = "_ts-0";